import { API_URL } from "config";
import Http from "util/https";
import { CSVThresholdCheckStock, CSVUploadThresholdParam, CSVUploadThresholdResponseApi } from "../types/index";
import { stockVisibleTypeLabel } from "../constants";


/**
 * 仕入先・外部倉庫用在庫一覧Api
 * @param params 在庫一覧Apiのパラメータ
 * @returns CSVThresholdCheckStock[]
 */
export default async function getCsvThresholdConfirmApi(params: CSVUploadThresholdParam) {
  const http = Http.default.alterAuth({useToken: true, useFormData: true});
  const url = `${API_URL}/stock/setting/csv/upload`;
  const res = await http.post<CSVUploadThresholdResponseApi>(url, Http.convertObjectToFormData(params));

  const stocks: CSVThresholdCheckStock[] = res.data.list.map(s => (
    {
      JANCd: s.jan_cd,
      productCd: s.item_cd,
      symbolThresholdList: [Number(s.threshold_max), Number(s.threshold_min)],
      stockVisibleType: stockVisibleTypeLabel[Number(s.display_mode)],
      isDiscontinued: !!Number(s.discontinued_flag), // "0"のような文字列として送られてくるためこうしている
      error: s.error ?? undefined,
    }
  ));

  console.log(res);
  console.log(stocks);
  return {
    stocks,
    processId: res.data.process_id,
    total: res.data.total,
    // error: res.data.list.some(s => s.error) ? 'エラーがあります。修正してからもう一度アップロードしてください。' : undefined
    // error: (res.data.errors && res.data.errors.length > 0) ? res.data.errors.join('\n').slice(0,100) : undefined,
    error: (res.data.errors && res.data.errors.length > 0) ? `${res.data.errors.slice(0,10).join('\n')}${res.data.errors.length > 10 ? `\n （その他${res.data.errors.length - 10}件）` : ""}` : undefined,
  };
}
